<template>
	<div class="puzzle-list">
		<router-link
			v-if="title"
			:to="$t('WordscapesDailyDetailInternalLinksTableHeadingUrl')"
			:title="
				$t(
					'WordscapesDailyDetailInternalLinksTableHeadingTitleAttribute'
				)
			"
			class="puzzle-list__title"
		>
			{{ title }}
		</router-link>
		<ul class="puzzle-list__items">
			<li v-if="!isToday" class="puzzle-list__item">
				<router-link
					:style="{
						background: color(currentDate),
						borderColor: color(currentDate),
					}"
					:to="itemUrl(currentDate)"
					:title="textTitleAttr(currentDate)"
					class="puzzle-list__box puzzle-list__box--current"
					v-html="text(currentDate)"
				/>
			</li>
			<li
				v-for="entry in items"
				:key="entry.date"
				class="puzzle-list__item"
			>
				<router-link
					:style="{ borderColor: color(entry) }"
					:to="itemUrl(entry)"
					:title="textTitleAttr(entry)"
					class="puzzle-list__box"
					v-html="text(entry)"
				/>
			</li>
		</ul>
	</div>
</template>

<script>
import { currentDateAsObject } from "@/common/functions";
import { DAILY_COLORS } from "@/common/daily_colors";

export default {
	name: "PuzzleList",
	props: {
		title: {
			type: String,
			required: true,
		},
		date: {
			type: Object,
			required: true,
		},
		dateList: {
			type: Array,
			required: true,
		},
	},
	data: function() {
		return {
			DAILY_COLORS,
		};
	},
	computed: {
		currentDate() {
			return currentDateAsObject();
		},
		isToday() {
			const currentDate = new Date();
			const pageDate = new Date(
				`${this.date.month} ${this.date.day}, ${this.date.year}`
			);
			return currentDate.toDateString() === pageDate.toDateString();
		},
		items() {
			return !this.isToday ? this.dateList.slice(0, 2) : this.dateList;
		},
	},
	methods: {
		text(date) {
			const dictKey =
				this.currentDate.day === +date.day
					? "WordscapesDailyInternalLinkTodayText"
					: "WordscapesDailyInternalLinkText";
			return this.$t(dictKey, {
				DayOrdinalFormat: date.day,
				Month: date.month.slice(0, 3),
				year: date.year,
			});
		},
		textTitleAttr(date) {
			return this.$t("WordscapesDailyInternalLinkTitleAttribute", {
				DayOrdinalFormat: date.day,
				Month: date.month,
				year: date.year,
			});
		},
		color(date) {
			const month = new Date(Object.values(date)).getMonth();
			return DAILY_COLORS[month][date.day - 1];
		},
		itemUrl(date) {
			return `/daily-puzzle/${date.month.toLowerCase()}-${date.day}-${
				date.year
			}-answers`;
		},
	},
};
</script>

<style lang="scss" scoped src="./styles.scss"></style>
